// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license

import { registerIcons as registerIcons_ } from "@fluentui/react";

export function registerIcons() {
    registerIcons_({
        fontFace: {
            fontFamily: "FabricMDL2Icons",
        },
        icons: {
            AccountManagement: "\uF55C",
            Add: "\uE710",
            AddField: "\uE4C7",
            AddTo: "\uECC8",
            AlertSolid: "\uF331",
            AutoEnhanceOff: "\uE78E",
            AutoEnhanceOn: "\uE78D",
            AzureAPIManagement: "\uF37F",
            Asterisk: "\uEA38",
            BookAnswers: "\uF8A4",
            BranchMerge: "\uF295",
            Build: "\uF28F",
            Cancel: "\uE711",
            Checkbox: "\uE739",
            CheckboxComposite: "\uE73A",
            CheckMark: "\uE73E",
            ChevronDown: "\uE70D",
            ChevronLeft: "\uE76B",
            ChevronRight: "\uE76C",
            ChevronUp: "\uE70E",
            ChromeMinimize: "\uE921",
            ChromeRestore: "\uE923",
            CircleRing: "\uEA3A",
            ClearFilter: "\uEF8F",
            Cloud: "\uE753",
            ContactCard: "\uEEBD",
            Copy: "\uE8C8",
            Delete: "\uE74D",
            Documentation: "\uEC17",
            DocumentManagement: "\uEFFC",
            Down: "\uE74B",
            Download: "\uE896",
            Edit: "\uE70F",
            FieldChanged: "\uF2C3",
            FieldNotChanged: "\uF2C4",
            Filter: "\uE71C",
            GroupedList: "\uEF74",
            GroupList: "\uF168",
            Help: "\uE897",
            Hide3: "\uF6AC",
            Home: "\uE80F",
            Info: "\uE946",
            Info12: "\uE55A",
            Insights: "\uE3AF",
            KeyPhraseExtraction: "\uE395",
            Label: "\uE932",
            Link: "\uE71B",
            MachineLearning: "\uE3B8",
            MapLayers: "\uE81E",
            Merge: "\uE7D5",
            More: "\uE712",
            OpenFolderHorizontal: "\uED25",
            Plug: "\uF300",
            PlugConnected: "\uF302",
            ReceiptProcessing: "\uE496",
            AddTable: "\uE4C6",
            InsertColumnsRight: "\uF64B",
            InsertRowsBelow: "\uF64D",
            EditTable: "\uE4C4",
            TableGroup: "\uF6D9",
            FixedColumnWidth: "\uE3EA",
            RectangleShape: "\uF1A9",
            Refresh: "\uE72C",
            Relationship: "\uF003",
            Rename: "\uE8AC",
            Rocket: "\uF3B3",
            Rotate90Clockwise: "\uF80D",
            TableBrandedColumn: "\uE3F1",
            TableBrandedRow: "\uE3EE",
            UpdateRestore: "\uE777",
            TableFirstColumn: "\uE3EF",
            TableHeaderRow: "\uE3EC",
            Rotate90CounterClockwise: "\uF80E",
            Search: "\uE721",
            Settings: "\uE713",
            Share: "\uE72D",
            SortDown: "\uEE69",
            SortUp: "\uEE68",
            SquareShape: "\uF1A6",
            StatusCircleCheckmark: "\uF13E",
            System: "\uE770",
            Table: "\uED86",
            Tag: "\uE8EC",
            TagGroup: "\uE3F6",
            TextDocument: "\uF029",
            TextField: "\uEDC3",
            Up: "\uE74A",
            View: "\uE890",
            WarningSolid: "\uF736",
            ZoomIn: "\uE8A3",
            ZoomOut: "\uE71F",
            CloudUpload: "\uEC8E",
            Upload: "\uE898",
            Signout: "\uF3B1",
            Accept: "\uE8FB",
            Undo: "\uE7A7",
            CopyText: "\uE464",
            CollapseMenu: "\uEF66",
            Save: "\uE74E",
            SaveAs: "\uE792",
            SaveTemplate: "\uF6EC",
            UserOptional: "\uF767", 
            EraseTool: "\uE75C"
        },
    });
}
